import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVideoCamera } from '@fortawesome/free-solid-svg-icons'
import defaultAvatar from '../Images/avatar1.png'

// firebase
import { db } from '../firebase';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, query, getDocs, where } from "firebase/firestore";

//sweetalert
import swal from 'sweetalert';

//routers
import { useNavigate } from "react-router-dom";
import wanadamu from '../Images/wanadamu.png'

function MyActiveRomms() {
  const auth = getAuth();
  let navigate = useNavigate();
  const [studentsList, setStudentList] = useState([]);
  const [loading, setLoading] = useState(true); // loading state

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;

        const i = query(collection(db, "users"), where("userId", "==", uid));
        getDocs(i).then((QuerySnapshot) => {
          QuerySnapshot.forEach((doc) => {
            const studentStatus = doc.data().Status;
            const userStatus = doc.data().userStatus;

            if (studentStatus === "Ongoing") {
              swal({
                title: "Your student status is not yet active",
                text: "Please ensure your fee deposit is fully settled to begin your classes. For assistance, contact the administrator.",
                icon: "warning",
                buttons: {
                  cancel: "Cancel",
                  confirm: {
                    text: "Get Started",
                    value: true,
                    visible: true,
                    className: "swal-button--confirm",
                    closeModal: true
                  }
                }
              }).then((value) => {
                if (value) {
                  navigate("/fee-invoices");
                }
              });

            } if (userStatus === "Deferred" || userStatus == "Expelled" || userStatus == "Dropped") {
              swal("Error", "Your students account is inactive, kindly reach out to the administrator to resume learning", "warning").then(() => {
                navigate("/fee-invoices");
              });
            }

          });
        });

        const fetchData = async () => {
          const q = query(collection(db, "allclasses"));
          let studentsItem = [];
          const querySnapshot = await getDocs(q);

          for (const doc of querySnapshot.docs) {
            let theClassId = doc.data().roomID;
            let instructor = doc.data().instructor;

            const m = query(collection(db, "StudentsInClass"), where("studentID", "==", uid));
            const studentDocs = await getDocs(m);

            for (const thedoc of studentDocs.docs) {
              let classID = thedoc.data().classID;

              if (theClassId === classID) {
                const x = query(collection(db, "Employees"), where("docId", "==", instructor));
                const employeeDocs = await getDocs(x);

                for (const ourDoc of employeeDocs.docs) {
                  let employeeName = ourDoc.data().employeeName;
                  let profilePic = ourDoc.data().profilePic;
                  let userProfPic = profilePic || defaultAvatar;

                  studentsItem.push({ id: doc.id, ...doc.data(), employeeName, userProfPic });
                }
              }
            }
          }

          setStudentList(studentsItem);
          setLoading(false); // ✅ Finished loading
        };

        fetchData();
      }
    });
  }, []);

  function startChat(roomid) {
    navigate('/class-session', {
      state: {
        myData: roomid,
        attendanceSource: 'my-rooms',
      },
    });
  }

  return (
    <div className='academicComp'>
      <h5>My Class Rooms</h5>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : studentsList.length === 0 ? (
        <div className="d-flex flex-column justify-content-center align-items-center nocontentPage">
          <img src={wanadamu} alt="No data available"  />
          <p className='text text-muted'>You have not been assigned to any classrom</p>
        </div>
      ) : (
        <div className='courseContainer'>
          {studentsList.map((mystudent) => (
            <div className='teamsItem2' key={Math.random()}>
              <div className='teamsItemProfilecont2'>
                <div className='roomTopdesc'>
                  <div className='defaultAvatarCont'>
                    <img src={mystudent.userProfPic} className='defaultAvatar' alt="" />
                  </div>
                  <div className='roomTopContent'>
                    <h6>{mystudent.classDesc}</h6>
                    <p><FontAwesomeIcon icon={faVideoCamera} /> {mystudent.employeeName}</p>
                  </div>
                </div>

                <div className='roomTimeClasses'>
                  <div>
                    <p className='roomTimeClassesH'>Cohort Date</p>
                    <p className='roomTimeClassesP'>{mystudent.intakeDate}</p>
                  </div>
                  <div>
                    <p className='roomTimeClassesH'>Start Time</p>
                    <p className='roomTimeClassesP'>{mystudent.startTime}</p>
                  </div>
                  <div>
                    <p className='roomTimeClassesH2'>End Time</p>
                    <p className='roomTimeClassesP2'>{mystudent.endTime}</p>
                  </div>
                </div>

                <div>
                  <button onClick={() => startChat(mystudent.roomID)} className='joinMyClass'>Join Class</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

    </div>
  );
}

export default MyActiveRomms;
